import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BlockSuggestionState {
  startBlock: number | null;
  endBlock: number | null;
  isClicked?: boolean;
}

const initialState: BlockSuggestionState = {
  startBlock: null,
  endBlock: null,
  isClicked: false,
};

const BlockSuggestionSlice = createSlice({
  name: "BlockSuggestion",
  initialState,
  reducers: {
    setBlockRange: (
      state: BlockSuggestionState,
      action: PayloadAction<{
        startBlock: number | null;
        endBlock: number | null;
        isClicked?: boolean;
      }>
    ) => {
      state.startBlock = action.payload.startBlock;
      state.endBlock = action.payload.endBlock;
      state.isClicked = action.payload.isClicked ?? false;
    },
  },
});

export const { setBlockRange } = BlockSuggestionSlice.actions;
export default BlockSuggestionSlice.reducer;
